import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FileText, BookOpen } from 'lucide-react';
import { apiClient } from '../../utils/apiHelper';

const LibraryFeeReport = () => {
  const [fees, setFees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchFees(); }, []);

  const fetchFees = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get('/api/library/fees');
      setFees(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error:', error);
      // Fallback - try to get from incomes
      try {
        const incomes = await apiClient.get('/api/accounts/incomes?limit=10000');
        const libraryFees = (incomes.data || []).filter(i => i.category?.toLowerCase().includes('library'));
        setFees(libraryFees);
      } catch (e) {
        console.error('Fallback error:', e);
      }
    } finally {
      setLoading(false);
    }
  };

  const totalFees = fees.reduce((sum, f) => sum + (f.amount || 0), 0);

  return (
    <div className="p-6 space-y-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <BookOpen className="w-5 h-5 text-blue-600" />
            Library Fee Report
          </CardTitle>
          <Button onClick={fetchFees} disabled={loading}>
            <FileText className="w-4 h-4 mr-2" />{loading ? 'Loading...' : 'Refresh'}
          </Button>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-sm text-blue-600">Total Entries</p>
              <p className="text-2xl font-bold text-blue-700">{fees.length}</p>
            </div>
            <div className="p-4 bg-green-50 rounded-lg border border-green-200">
              <p className="text-sm text-green-600">Total Collection</p>
              <p className="text-2xl font-bold text-green-700">₹{totalFees.toLocaleString('en-IN')}</p>
            </div>
          </div>

          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b bg-gray-50">
                <th className="text-left p-3">Date</th>
                <th className="text-left p-3">Description</th>
                <th className="text-left p-3">Payment Mode</th>
                <th className="text-right p-3">Amount</th>
              </tr>
            </thead>
            <tbody>
              {fees.length === 0 ? (
                <tr><td colSpan="4" className="text-center p-8 text-gray-500">No library fee records found.</td></tr>
              ) : (
                fees.map((fee, idx) => (
                  <tr key={idx} className="border-b hover:bg-gray-50">
                    <td className="p-3">{fee.income_date || fee.date}</td>
                    <td className="p-3">{fee.description || fee.category}</td>
                    <td className="p-3">
                      <span className={`px-2 py-1 text-xs rounded-full ${fee.payment_mode === 'Cash' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                        {fee.payment_mode || 'N/A'}
                      </span>
                    </td>
                    <td className="p-3 text-right text-green-600 font-semibold">₹{fee.amount?.toLocaleString('en-IN')}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
};

export default LibraryFeeReport;
